import { CardContent, CardHeader } from './card';
import { cn } from './utils/cn';
import { FCC } from './utils/fcc';

export const EluveCardHeader: FCC = ({ children }) => {
  return (
    <CardHeader className="flex h-10 flex-row place-items-center justify-between space-y-0 rounded-t-xl border-b bg-bg-primary p-0 px-5 tracking-normal group-data-closed:border-none group-data-closed:bg-transparent">
      {children}
    </CardHeader>
  );
};

export const EluveCardContent: FCC<{ className?: string }> = ({
  children,
  className,
}) => {
  return (
    <CardContent
      className={cn(
        'flex flex-col gap-5 rounded-b-xl bg-white p-5 md:flex-col',
        className,
      )}
    >
      {children}
    </CardContent>
  );
};
